import { customerRequestContants } from '../../_constants';

export function customerRequest(state = {}, action) {
    switch (action.type) {
        case customerRequestContants.RESET:
            return {}
        case customerRequestContants.REQUEST_FETCHING:
            return {
                ...state,
                requestFetching: true,
            };
        case customerRequestContants.REQUEST_FETCHED:
            return {
                ...state,
                requestFetching: false,
            };
        case customerRequestContants.REQUEST_SUBMITTING:
            return {
                ...state,
                requestSubmitting: true,
            };
        case customerRequestContants.REQUEST_SUBMITTED:
            return {
                ...state,
                requestSubmitting: false,
            };
        case customerRequestContants.SEARCH_COMPANY:
            return {
                ...state,
                companySearched: action.companySearched,
            };
        case customerRequestContants.LOAD_COMPANY_REQUEST:
            return {
                ...state,
                loadCompanyRequest: action.loadCompanyRequest,
            };
        case customerRequestContants.GET_COMPANY_REQUEST_BY_ID:
            return {
                ...state,
                getRequestById: action.getRequestById,
            };
        default:
            return state;
    }
}